"use client";

import { useCallback, useMemo, useState } from "react";
import type { HubExchangeAccount } from "@cede/types";
import type { ExchangeSessionResult } from "../types";
import { useZeroOneConnection } from "./useZeroOneConnection";
import { WALLET_ACTION_ROLE } from "@/hooks/core/useWalletActionGuard";

export function useZeroOneSession(): ExchangeSessionResult {
  const zeroOneConnection = useZeroOneConnection();

  const [selectedAccountId, setSelectedAccountId] = useState<number | null>(null);
  const selectedAccount = useMemo(() => {
    const accts = zeroOneConnection.zerooneAccounts;
    if (selectedAccountId != null) return accts.find((a) => a.id === selectedAccountId) ?? null;
    return accts[0] ?? null;
  }, [zeroOneConnection.zerooneAccounts, selectedAccountId]);

  const setSelectedAccount = useCallback(
    (account: HubExchangeAccount | null) => setSelectedAccountId(account?.id ?? null),
    [],
  );

  return {
    connection: zeroOneConnection,
    sessionStatus: zeroOneConnection.sessionStatus,
    accounts: zeroOneConnection.zerooneAccounts,
    selectedAccount,
    setSelectedAccount,
    handleSetupAction: () => {},
    isSettingUp: false,
    requiredWalletRole: WALLET_ACTION_ROLE.LINKED_SOLANA,
    requiredWalletAddress: zeroOneConnection.connectedAddress,
    exchangeAccountAddress: zeroOneConnection.agentData.agentAddress,
    needsDeposit: false,
  };
}
